import { vpp, VPP_API } from '../api/vpp';
import * as types from './types';

const setTows = (payload) => ({ type: types.SET_TOWS, payload });

export const getTows = (search) => (dispatch) =>
  vpp.get(VPP_API.tows, search ? { params: search } : null).then(({ data }) => {
    dispatch(setTows(data));
  });
